// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CodeList_wrapper__t_O2v"};